import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "@propelauth/react";
import { App } from "./App";
import { authClient } from "./authClient";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider client={authClient}>
      <App />
    </AuthProvider>
  </StrictMode>
);
